import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { UiService } from 'src/app/admin/service/ui.service';
import { PaisComponent } from '../../modals/pais/pais.component';
import { BalanceService } from '../../services/balance.service';
import { IdiomaService } from '../../services/idioma.service';
import { PaisService } from '../../services/pais.service';
import { StorageService } from '../../services/storage.service';
import { LangComponent } from '../lang/lang.component';

@Component({
  selector: 'Amarillas-multio',
  templateUrl: './multio.component.html',
  styleUrls: ['./multio.component.scss'],
})
export class MultioComponent implements OnInit {
  @Input() currency = false;
  selectedCountry = this.paisService.countrys[0];
  langages = this.idiomaService.selectLangages;
  selectedLang;
  buttonsSegment = [
    {
      txt: 'SENTENSES.IDIOMA_Y_REGION',
      value: 'langage'
    },
    {
      txt: 'WORDS.MONEDA',
      value: 'currency'
    }
  ]
  type: string = this.buttonsSegment[0].value;
  currencies: any[] = [];

  constructor(
    private uiSv: UiService,
    private paisService: PaisService,
    private idiomaService: IdiomaService,
    private storageSv: StorageService,
    private balanceService: BalanceService,
    public popoverController: PopoverController
  ) { }

  async ngOnInit() {
    try{
      if(this.currency){
        this.type = 'currency';
      }
      const lang = await this.storageSv.get('langage');
      this.selectedLang = this.langages.find(item => item.code === lang);
      const res: any = await this.balanceService.getCurrencies();
      this.currencies = res.data;      
    }catch(err){
      console.log(err);
      
    }
  }

  async accept(){
    await this.popoverController.dismiss();
  }

  async modalPais() {
    const { data, role } = await this.uiSv.createPop( PaisComponent )
    if (data) {
      this.selectedCountry = await this.paisService.selectCountry( data );
    }
  }

  async changeLang(event) {
    const { data } = await this.uiSv.createPop( LangComponent, { langages: this.langages }, undefined, event )
    if (data) {
      await this.idiomaService.changeLangage( data );
      this.selectedLang = this.langages.find(item => item.code === data);
    }
  }

  setCurrency(currency){
    this.storageSv.set('currency', currency);
    this.balanceService.currencySource.next(currency);
  }

}
